export default "__VITE_ASSET__BygD72UA__"